import { render } from "./DestinationView.vue?vue&type=template&id=5253bb94"
import script from "./DestinationView.vue?vue&type=script&lang=js"
export * from "./DestinationView.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__